<template>
  <div id="examredroom">
    <!-- 隔离备用考场使用情况 -->

    <van-cell-group title="隔离备用考场使用情况" class="text-left" v-show="false">
      <template v-for="(item,index) in roomList">
        <van-cell :key="index" title="单元格" value="内容">
          <template slot="title">考场：{{item.RoomNo}} ({{item.RoomName}})</template>
          <template slot="default">
            <van-button @click="putExamRedRoom(item)">{{'当前'+item.RoomStateName}}</van-button>
          </template>
          <template slot="label">考生:{{item.StuNum}}</template>
        </van-cell>
      </template>
    </van-cell-group>
  </div>
</template>

<script>
export default {
  name: "examredroom",
  data() {
    return {
      roomList: [],
    };
  },
  props: {
    SplitProcessID: String, //分解环节ID
    ProcessData: Object, //工作环节数据
    ProcessRefresh: Function, //工作环节刷新事件
    completeBtnAttribute: Object, //工作环节上报完成按钮
  },
  methods: {
    //获取隔离备用考场列表
    getExamRedRoomList() {
      this.apiExamRedRoomGet(
        {
          WorkID: this.getWork().WorkID,
          SplitProcessID: this.SplitProcessID,
        },
        this,
        (res) => {
          console.log("获取隔离备用考场返回内容 res", res);
          if (res.code == 20000) {
            this.roomList = res.data;
          } else {
            this.$toast(res.message);
          }
        }
      );
    },
    //停用/启用隔离备用考场信息
    putExamRedRoom(item) {
      this.apiExamRedRoomPut(
        {
          WorkID: this.getWork().WorkID,
          SplitProcessID: this.SplitProcessID,
          RoomState: item.RoomState == 1 ? 3 : 1, //启用或禁用状态 1：启用 3：禁用
          RoomID: item.RoomID, //全部禁用RoomID=-1, 单条禁用或启用传相应RoomID
        },
        this,
        (res) => {
          if (res.code == 20000) {
            this.getExamRedRoomList();
          } else {
            this.$toast(res.message);
          }
        }
      );
    },
  },
  created() {
    this.getExamRedRoomList();
  },
};
</script>

<style scoped>
</style>